import { wrap as withStyle } from 'utils/styles'

export default withStyle(
  () => `
  margin-top: 20px;

  button {
    font-size: 12px;
    text-align: left;
  }
`
)
